




















import { computed, defineComponent } from '@vue/composition-api';
import { useGlobals }                from '@/hooks/use-globals';
import { useSidePanel }              from '@/views/users/hooks/use-side-panel';
import cIconHamburger                from '@/components/icons/icon-hamburger.component.vue';
import cIconGrid                     from '@/components/icons/icon-grid.component.vue';
import cIconWithLabel                from '@/components/icon-with-label/icon-with-label.component.vue';
import cPlusButton                   from '@/components/custom/buttons/plus-button/plus-button.component.vue';
import { View }                      from '@/views/users/users.types';
import { Computed }                  from '@/types';

export default defineComponent({
  name: 'cUsersHeader',
  components: {
    cIconHamburger,
    cIconGrid,
    cIconWithLabel,
    cPlusButton,
  },
  setup() {
    const { store, i18n } = useGlobals();
    const { showAddUserFormPanel } = useSidePanel();
    const mode: Computed<View> = computed((): View => store.state.views.vUsers.view);

    const setViewMode = (payload: View): void => {
      store.commit('views/vUsers/setViewMode', payload);
    };

    return {
      i18n,
      cIconHamburger,
      cIconGrid,
      mode,
      View,
      setViewMode,
      showAddUserFormPanel,
    };
  },
});
